var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{class:_vm.bodyClass},[(_vm.showAside)?_c('aside',{staticClass:"page-split__aside",class:_vm.spacingClass},[_vm._t("aside")],2):_vm._e(),_c('main',{staticClass:"page-split__main",class:_vm.spacingClass},[_vm._t("main")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }